<template>
  <b-modal ref="modal" hide-footer title="Change Status" v-if="lookups != null">
    <b-row class="my-1">
      <b-col md="3">
        <label for="statuses">New Status</label>
      </b-col>
      <b-col md="9">
        <b-form-select
          id="statuses"
          v-model="selectedStatus"
          :options="companyStatuses"
          value-field="id"
          text-field="name"
        >
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="9"> </b-col>
      <b-col md="3">
        <b-button
          class="mt-3"
          variant="success"
          block
          @click="saveStatus"
          :disabled="selectedStatus == null || isBusy"
        >
          Save
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>

export default {
  props: {
    companyId: String,
    lookups: Object
  },
  data() {
    return {
      //statuses: [],
      selectedStatus: null,
      isBusy: false,
    };
  },
  computed: {
    companyStatuses() {
      if (!this.lookups) return [];

      var array = [...this.lookups.companyStatuses];

      if (array[0].id == 0) {
        array[0].disabled = true
      }

      return array;
    }
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },

    saveStatus() {
      if (!this.isBusy){
        this.isBusy = true;
        this.$http.post("/company/status", { companyId: this.companyId, companyStatusId: this.selectedStatus}).then(() => {
          this.isBusy = false;
          this.$parent.$parent.loadData();
          this.hideModal();
        });
      }      
    },
  },
};
</script>
